import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngdoc pipe
 * @name ApKeyOverridePipe
 * @module ApContentModule
 *
 * @description
 * This filter maps a source key to a target key using a key-map object.
 * The filter can be used in templates for letting consumers overwrite component content.
 */
@Pipe({ name: 'apKeyOverride' })
export class ApKeyOverridePipe implements PipeTransform {
    transform(key: string, keyMap?: { [key: string]: string }): string {
        return keyMap && keyMap[key] ? keyMap[key] : key;
    }
}
